import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import axios from 'axios';
import { WEBSERVICE_IP } from '../../functions/roots/webserviceIP';

const DificultadPorSemana = () => {
  const [datos, setDatos] = useState([]);
  const usuarioId = sessionStorage.getItem('usuarioId');

  useEffect(() => {
    const fetchDificultad = async () => {
      try {
        const res = await axios.get(`${WEBSERVICE_IP}/reportes/grafica/dificultad-por-semana/${usuarioId}`);
        const { semanas, dificultades, tasaCambio } = res.data;

        const formateado = semanas.map((semana, i) => ({
          semana,
          dificultad: dificultades[i],
          cambio: i < tasaCambio.length ? tasaCambio[i] : null
        }));

        setDatos(formateado);
      } catch (error) {
        console.error('Error al obtener dificultad por semana:', error);
      }
    };

    if (usuarioId) fetchDificultad();
  }, [usuarioId]);

  return (
    <div className="w-full max-w-5xl px-4">
      {datos.length > 0 ? (
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={datos} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="semana" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="dificultad" name="Dificultad" stroke="#6366f1" strokeWidth={2} dot={{ r: 4 }} />
            <Line type="monotone" dataKey="cambio" name="Tasa de Cambio" stroke="#f97316" strokeWidth={2} strokeDasharray="5 5" />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <p className="text-gray-500 text-center">Cargando datos...</p>
      )}
    </div>
  );
};

export default DificultadPorSemana;
